import styles from "./eventsAgenda.module.scss";
import { Tooltip } from "@mui/material";
import { EventLegendData } from "helpers/models";
import { ReactComponent as MyLocationSvg } from "assets/my_location.svg";
import { MapContext } from "helpers/map";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

interface Props extends EventLegendData {
	onClose?: () => void;
}

interface LegendColor {
	raster: {
		color?: string;
		opacity?: number;
	};
	polygon: {
		fill?: string;
		fillOpacity?: number;
		stroke?: string;
		strokeDashArray?: any;
		strokeOpacity?: number;
	};
}

interface LegendItem {
	title: string;
	symbolizers: LegendColor[];
}

function Agenda(props: Props) {
	const [t] = useTranslation();
	const { AMap, map } = useContext(MapContext);

	const handleClickMyLocation = () => {
		const isCross180 = props.layerInfo.extent.minimumLongitude > props.layerInfo.extent.maximumLongitude;
		const southWest = new AMap.LngLat(props.layerInfo.extent.minimumLongitude, props.layerInfo.extent.minimumLatitude, isCross180);
		const northEast = new AMap.LngLat(isCross180 ? props.layerInfo.extent.maximumLongitude + 360 : props.layerInfo.extent.maximumLongitude, props.layerInfo.extent.maximumLatitude, isCross180);
		let myBounds = new AMap.Bounds(southWest, northEast);
		map?.setBounds(myBounds, true, [20, 20, 20, 20]);
	}

	const handleStyleDisplay = (item: LegendItem) => {
		if (item.symbolizers[0].raster) {
			return item.symbolizers[0].raster.opacity === 0 ? "none" : "flex"
		} else {
			return item.symbolizers[0].polygon.fillOpacity === 0 ? "none" : "flex"
		}
	}

	return (
		<div className={styles.agenda}>
			<div className={styles.header}>
				<Tooltip title={props.layerInfo.name}>
					<div className={styles.text}>{props.layerInfo.name}</div>
				</Tooltip>
				<div className="flex">
					<MyLocationSvg
						id="loc"
						className="w-[16px] h-[16px] fill-[#0009] cursor-pointer mr-[5px]"
						onClick={handleClickMyLocation}
					/>
					<div
						role="button"
						tabIndex={0}
						className={`material-icons ${styles.icon}`}
						onClick={props.onClose}
					>
						cancel
					</div>
				</div>
			</div>
			<div>
				{props.subtitle && <div className={styles.subtitle}>{t("legend." + props.subtitle)}</div>}
				<div className={styles.legend}>
					{props.rules &&
						props.rules.map((item: LegendItem, index: number) => (
							<div
								key={item.title + index}
								style={{
									display: handleStyleDisplay(item),
									alignItems: "center",
								}}
							>
								<span
									style={{
										backgroundColor: item.symbolizers[0].raster ? item.symbolizers[0].raster.color : item.symbolizers[0].polygon.fill,
										opacity: item.symbolizers[0].raster ? item.symbolizers[0].raster.opacity : item.symbolizers[0].polygon.fillOpacity,
									}}
								></span>
								{t("legend." + item.title)}
							</div>
						))}
				</div>
			</div>
		</div>
	);
}

export default Agenda;
